import { useMutation } from '@tanstack/react-query';
import { userAssignedCities } from '../../user-cities';

interface UseGetUserAssignedCitiesParams {
  onSuccess?: (data: string[]) => void;
  onError?: (error: unknown) => void;
}

export const useGetUserAssignedCities = ({
  onSuccess,
  onError,
}: UseGetUserAssignedCitiesParams = {}) => {
  const {
    mutate: getUserAssignedCitiesMutation,
    data,
    isPending: isLoading,
    isError,
    isSuccess,
  } = useMutation({
    mutationFn: userAssignedCities,
    onSuccess,
    onError,
  });

  return {
    getUserAssignedCitiesMutation,
    assignedCities: data,
    isLoading,
    isError,
    isSuccess,
  };
};
